import { render, staticRenderFns } from "./RoundStatsTable.vue?vue&type=template&id=32400ae8&scoped=true&"
import script from "./RoundStatsTable.vue?vue&type=script&lang=js&"
export * from "./RoundStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./RoundStatsTable.vue?vue&type=style&index=0&id=32400ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32400ae8",
  null
  
)

export default component.exports